import { Box, Select, Tooltip } from "@chakra-ui/react";
import { IOSZAMLA_BESZLA_FEJ_PUB, TSzamlaFilter } from "@coimbra-its/api.konyvelo";
import { CellProps, formatDate, formatNumber, useWSysLayoutContext, useWSysMainTable, useWSysPage, useWSysPath, WSysPage, WSysSearch, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core";
import { useKonyveloApi } from "../store/konyvelo.api";
import { Beszla } from "./Beszla";
import { PushNotificationButton } from "../components/PushNotificationButton";
import { WSysTableSettings } from "../temp/TableSettings";

//const CELLS = new TableMeta(OSZAMLA_BESZLA_FEJ_META).forTable();

export const CELLS: CellProps<IOSZAMLA_BESZLA_FEJ_PUB>[] = [
	{ 'title': 'Szállító', elem: (row) => row.SUPPLIERNAME, charWidth: 40, field: 'SUPPLIERNAME' },
	{ 'title': 'Számlaszám', elem: (row) => row.INVOICENUMBER, charWidth: 20, field: 'INVOICENUMBER' },
	{ 'title': 'Dátum', elem: (row) => formatDate(row.INVOICEISSUEDATE), charWidth: 11, field: 'INVOICEISSUEDATE' },
	{ 'title': 'Bruttó', elem: (row) => formatNumber(row.INVOICENETAMOUNT + row.INVOICEVATAMOUNT, 0) + ' ' + (row.CURRENCY === 'HUF' ? 'Ft' : row.CURRENCY), charWidth: 11, align: 'right', field: 'INVOICENETAMOUNT' },
	{
		'title': 'Státusz', elem: (row) => {
			let status = '';
			switch (row.OSZAMLA_IMPORT) {
				case 'T': status = 'Kész'; break;
				case 'N': status = row.KEPEK > 0 ? 'Kézzel rögzítve' : 'Kézzel rögzítve (nincs kép)'; break;
				case 'R': status = row.KEPEK > 0 ? 'Számlakép rögzítve' : 'Nincs számlakép'; break;
				default: status = 'Besorolásra vár'; break;
			}
			if (row.INVOICEOPERATION != 'CREATE')
				status += ' ('+row.INVOICEOPERATION+'!)';
			if (!row.ERROR)
				return <>{status}</>;
			else 
				return <>{status}<Box as='span' bgColor='red' color='#fff' p='0 4px' fontSize='xs' display='inline-block' ml={1} borderRadius='md' >{row.ERROR}</Box></>
		}, charWidth: 20, field: 'OSZAMLA_IMPORT'
	},
];


export function BeszlaOnlineLista() {


	const path = useWSysPath();
	const [q] = path.useParam('q');
	const [statusz, setStatusz] = path.useParamValue<TSzamlaFilter>('status', 'besorol', val => val, val => val as TSzamlaFilter);
	const tableProps = useWSysMainTable(path, [q, statusz]);

	const api = useKonyveloApi();
	const [szamlaGetRes, hub] = api.beszlaOnlineGet.useData({ statusz, q, ...tableProps.forPath });
	const szamlak = szamlaGetRes?.szamlak.items || [];

	const szamlaPath = path.useChildRow('', szamlak, szamla => szamla.ID);
	const layout = useWSysLayoutContext();
	const page = useWSysPage({ title: 'Online számlák', maxCols: szamlaPath.isOpen ? (Math.max(layout.widthCols - 4, 2)) : 10 });


	return <WSysPage page={page} hubs={[hub]}

		tools={<Box display='flex' gap={2}>
			<WSysSearch name='q' />
			<Select size='sm' value={statusz} onChange={e => setStatusz(e.currentTarget.value as TSzamlaFilter)}>
				<option value='besorol' >Besorolásra vár</option>
				<option value='feltolt' >Kép feltöltés</option>
				<option value='nincskesz' >Új</option>
				<option value='mind'>Mind</option>
			</Select>
			<PushNotificationButton subject={'beszla_online'} />
			<WSysTableSettings orderBy={tableProps.forTable.orderBy} orderByChanged={tableProps.forTable.orderByChanged} cells={CELLS} reset={{orderBy:'', title:'Alaphelyzet (ID desc)'}} />
		</Box>}

	>
		<WSysVert mode="rest">
			<WSysTable
				cells={CELLS}
				rows={szamlak}
				tableInfo={szamlaGetRes?.szamlak.info}
				{...szamlaPath.forTable}
				{...tableProps.forTable}
				mode={3}
				noHead={layout.isMobileFull}

				
			/>
		</WSysVert>

		{szamlaPath.on(szamlaPath.forTable.selectedRow && <Beszla tipus="oszla" oszlaID_or_DokId={szamlaPath.forTable.selectedRow.ID}  />)}
	</WSysPage>
}